import { EActivityReportOptions, EActivityType } from '@constants';
import { TFunction } from 'i18next';

export const getActivityReportOptions = (
  activityType: EActivityType,
  t: TFunction<'DefaultTranslations'>
) => {
  if (activityType === EActivityType.VIDEO) {
    return [
      {
        value: t(EActivityReportOptions.LESSON_CONTENT),
        key: EActivityReportOptions.LESSON_CONTENT
      },
      {
        value: t(EActivityReportOptions.INCOMPLETE_CONTENT),
        key: EActivityReportOptions.INCOMPLETE_CONTENT
      },
      {
        value: t(EActivityReportOptions.WRONG_INFORMATION),
        key: EActivityReportOptions.WRONG_INFORMATION
      },
      {
        value: t(EActivityReportOptions.TECHNICAL_PROBLEM),
        key: EActivityReportOptions.TECHNICAL_PROBLEM
      },
      {
        value: t(EActivityReportOptions.OTHER_ACTIVITY_REPORT),
        key: EActivityReportOptions.OTHER_ACTIVITY_REPORT
      }
    ];
  }
  return [
    { value: t(EActivityReportOptions.LESSON_CONTENT), key: EActivityReportOptions.LESSON_CONTENT },
    {
      value: t(EActivityReportOptions.INCOMPLETE_CONTENT),
      key: EActivityReportOptions.INCOMPLETE_CONTENT
    },
    { value: t(EActivityReportOptions.AUDIO_OR_VIDEO), key: EActivityReportOptions.AUDIO_OR_VIDEO },
    {
      value: t(EActivityReportOptions.TEACHER_EXPLANATION),
      key: EActivityReportOptions.TEACHER_EXPLANATION
    },
    { value: t(EActivityReportOptions.REPEATED_VIDEO), key: EActivityReportOptions.REPEATED_VIDEO },
    {
      value: t(EActivityReportOptions.TECHNICAL_PROBLEM),
      key: EActivityReportOptions.TECHNICAL_PROBLEM
    },
    {
      value: t(EActivityReportOptions.OTHER_ACTIVITY_REPORT),
      key: EActivityReportOptions.OTHER_ACTIVITY_REPORT
    }
  ];
};
